document.addEventListener('DOMContentLoaded', () => {
  const oneTime = document.querySelector('[skio-one-time]');
  const bullets = document.querySelector('.skio-group-content + div');
  const subscription__text = document.querySelector('.subscription__text');
  const subscribe = document.querySelector('[skio-selling-plan-group]');
  let content ;
  if(subscription__text) content = subscription__text.dataset.list;
  if (oneTime?.checked && bullets) {
    bullets.style.display = 'none';
  }   

  //description
  
const frequencies = document.getElementsByClassName('skio-group-content');

for (let i = 0; i < frequencies.length; i++) {
  frequencies[i].insertAdjacentHTML(
    'afterend',
    `<div class="subscription__text">
   ${content}
    </div>
    `
  );
}

});

document.addEventListener('change', () => {
  const oneTime = document.querySelector('[skio-one-time]');
  const subscribe = document.querySelector('[skio-selling-plan-group]');
  const bullets = document.querySelector('.skio-group-content + div');

  if (!bullets) return;

  if (oneTime.checked) {
    bullets.style.display = 'none';
  }

  if (subscribe.checked) {
    bullets.style.display = 'flex'; 
  }
});
